import { Component, OnInit, Inject, Injector } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Cluster } from '../../cluster/cluster.interface';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Area, AreaTemplate } from '../area.interface';
import { BasicAreaService } from '../../basic-area/basic-area.service';
import { AreaService } from '../area.service';
import { sortBy } from 'lodash-es';

@Component({
  selector: 'sg2-area-add',
  templateUrl: './area-add.component.html',
  styleUrls: ['./area-add.component.less']
})
export class AreaAddComponent implements OnInit {

  /** Area service from the injector. */
  private areaService: AreaService;

  /** Area list. */
  public areas: Area[];

  /** Area template service from the injector. */
  private areaTemplateService: BasicAreaService;

  /** Area templates list. */
  public areaTemplates: Partial<AreaTemplate>[];

  /** Form. */
  public form: FormGroup;

  /**
   * @todo Also add clusterService through injector?
   */
  constructor(
    @Inject(MAT_DIALOG_DATA) public readonly config: any,
    public dialogRef: MatDialogRef<AreaAddComponent>,
    private formBuilder: FormBuilder,
    private injector: Injector
  ) {
    /** @todo Fix in 2711 */
    /* tslint:disable-next-line */
    this.areaService = this.injector.get('AreaService');
    /** @todo Fix in 2711 */
    /* tslint:disable-next-line */
    this.areaTemplateService = this.injector.get('BasicAreaService');
  }

  ngOnInit() {
    this.areas = this.areaService.get().filter(a => a.active);
    this.areaTemplates = sortBy(this.areaTemplateService.get(), 'name');

    this._setForm();
  }

  /**
   * Initialize form and set validators.
   */
  private _setForm(): void {
    this.form = this.formBuilder.group({
      name: [null, [
        Validators.required,
        this._uniqueNameValidator.bind(this)
      ]],
      basicAreaId: this.areaTemplates[0]._id,
      quantity: [1, [
        Validators.required,
        Validators.min(0),
        Validators.pattern('^[0-9]+(\.[0-9]{0})?$')
      ]],
      height: [null, [
        Validators.min(0),
        Validators.pattern('^[0-9]+(\.[0-9]{1,2})?$')
      ]],
      surface: [0, [
        Validators.required,
        Validators.min(0),
        Validators.pattern('^[0-9]+(\.[0-9]{1,2})?$')
      ]],
      occupation: [null, [
        Validators.min(0),
        Validators.pattern('^[0-9]+(\.[0-9]{0})?$')
      ]],
      comment: null
    });
  }

  /**
   * Submit and add cluster.
   *
   * @note Somehow an area uses:
   *  - buildingId
   *  - clusterId
   *  - basicArea (without id??)
   *  So add `basicArea` as an extra property (just a copy of basicAreaId).
   *  This way, it should be easy to patch if this is addressed sometime.
   */
  public submit(): void {
    const areaTemplate = this.areaTemplates.find(at => at._id === this.form.get('basicAreaId').value);

    this.dialogRef.close({
      ...this.config.template,
      basicArea: areaTemplate._id,
      functionality: areaTemplate.functionality,
      ...this.form.value,
    });
  }

  /**
   * Check if the name is unique.
   *
   * @todo Create generic unique validator in utilities with two params
   *  - Add validator to form with: `this._uniqueNameValidator.bind(this, list)`.
   *  - Validator params will then be `_uniqueNameValidator(list, control)`.
   *  - Also see: https://stackoverflow.com/questions/36756159
   *
   * @param control The current form control.
   */
  private _uniqueNameValidator(control: FormControl): void {
    const names = this.areaTemplates
      .filter(t => t.active)
      .map(t => t.name);
    if (control.valid) {
      if (names.indexOf(control.value) > -1) {
        setTimeout(() => {
          control.setErrors({ unique: true });
        });
      }
    }
  }
}
